module.exports = __webpack_public_path__ + "assets/img/cha.9f2dbead.png";